"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _vuex = require("vuex");
var _TemplateMapDetail = _interopRequireDefault(require("../components/TemplateMapDetail"));
var _constants = require("@/config/constants");
var _base = _interopRequireDefault(require("base-64"));
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  name: 'MapFarmManagement',
  components: {
    Page: _Page.default,
    TemplateMapDetail: _TemplateMapDetail.default
  },
  data: function data() {
    return {
      mapMode: 'ready',
      mapDraggable: true,
      mapCursor: null,
      shapes: [],
      paths: [],
      drawingON: false,
      showModal: false,
      optionsAutoComplete: {
        componentRestrictions: {
          country: 'BR'
        },
        fields: ['ALL'],
        strictBounds: false
      },
      polygonOptions: {
        fillColor: '#90CC1B',
        fillOpacity: 0.6,
        strokeWeight: 4,
        strokeColor: '#90CC1B',
        draggable: false,
        editable: false,
        clickable: true
      },
      mapOptions: {
        backgroundColor: '#fff',
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        draggable: this.mapDraggable,
        draggableCursor: this.mapCursor
      },
      center: {
        lat: -16.2308349609375,
        lng: -56.033363342285156
      },
      zoom: 4,
      editDraw: false,
      selectedFeatures: [],
      coordinates: [],
      subPlotsQtd: _constants.NUMBER_SUB_PLOTS,
      isFetching: false,
      dataAddress: [],
      subPlotsList: {
        code: [],
        area: []
      },
      isErrorNickName: false,
      geolocPosition: undefined,
      propsEdit: {},
      propertiesPlot: {
        area: '',
        shape: {
          type: 'Polygon',
          coordinates: []
        }
      }
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (this.$route.query.data) {
              try {
                this.fetchSavedDataURL();
              } catch (error) {
                this.editDraw = false;
                this.$buefy.toast.open({
                  duration: 5000,
                  message: "Falha ao atualizar desenho no mapa, credenciais inv\xE1lidas!",
                  type: 'is-danger'
                });
              }
            }
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    menuItemsFarm: 'menuItemsFarm',
    farm: 'GET_FARM'
  })), {}, {
    polygonPaths: function polygonPaths() {
      if (!this.mvcPaths) return null;
      var paths = [];
      for (var i = 0; i < this.mvcPaths.getLength(); i++) {
        var path = [];
        for (var j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          var point = this.mvcPaths.getAt(i).getAt(j);
          path.push({
            lat: point.lat(),
            lng: point.lng()
          });
        }
        paths.push(path);
      }
      return paths;
    },
    sumSubPlotsArea: function sumSubPlotsArea() {
      var total = 0;
      this.subPlotsList.area.map(function (item) {
        total += Number(item) / 0.00010000;
      });
      return total;
    },
    validCalcTotalAreas: function validCalcTotalAreas() {
      var totalAreaSubPlot = 0;
      totalAreaSubPlot = this.subPlotsList.area.reduce(function (previous, current) {
        return previous + Number(current) * 10000;
      }, 0);
      var totalAreaPlot = Number(this.propertiesPlot.area);
      return totalAreaSubPlot <= totalAreaPlot;
    },
    showSelectIteraction: function showSelectIteraction() {
      return !this.drawType && this.coordinates.length;
    },
    focusSelect: function focusSelect() {
      return focus;
    }
  }),
  watch: {
    mapMode: function mapMode(newMode, oldMode) {
      if (newMode === 'ready') {
        if (oldMode === 'edit') {
          this.mapDraggable = true;
          this.mapCursor = null;
          return;
        }
      }
      if (newMode === 'edit') {
        this.mapDraggable = false;
        this.mapCursor = 'default';
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['setLoading', 'createPlot', 'updatePlot', 'createSubPlot', 'fetchPlotItem'])), {}, {
    handleOverlayComplete: function handleOverlayComplete(e) {
      this.shapes = [{
        overlay: e.overlay
      }];
      this.drawingON = false;
      e.drawingManager.setDrawingMode(null);
    },
    fetchSavedDataURL: function () {
      var _fetchSavedDataURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var idPlot, data, shape, pathsCoodinates, coordSaveds, validCoodinates;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              idPlot = _base.default.decode(this.$route.query.data);
              _context2.n = 1;
              return this.fetchPlotItem(idPlot);
            case 1:
              data = _context2.v;
              if (!data.id) {
                _context2.n = 3;
                break;
              }
              shape = data.shape;
              this.editDraw = true;
              this.coordinates = shape.coordinates;
              this.propertiesPlot = data;
              pathsCoodinates = [];
              coordSaveds = shape.coordinates.length <= 1 ? shape.coordinates[0] : shape.coordinates;
              validCoodinates = coordSaveds.map(function (i) {
                if (i[0] && i[1]) {
                  pathsCoodinates.push({
                    lng: Number(i[0]),
                    lat: Number(i[1])
                  });
                }
              });
              _context2.n = 2;
              return Promise.all(validCoodinates);
            case 2:
              // acrescentar aqui poligono
              this.paths = [pathsCoodinates];
              if (data.center) this.center = {
                lng: Number(data.center[0]),
                lat: Number(data.center[1])
              };
              if (data.zoom) this.zoom = data.zoom;
              this.propsEdit = {
                area: data.area,
                coordinates: this.paths
              };
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function fetchSavedDataURL() {
        return _fetchSavedDataURL.apply(this, arguments);
      }
      return fetchSavedDataURL;
    }(),
    searchLocation: function searchLocation(place) {
      if (place.geometry) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
      } else {
        var name = place.name;
        var coordinates = name.length > 0 ? name.split(',') : [];
        if (coordinates.length === 2) {
          this.center = {
            lat: Number(coordinates[0]),
            lng: Number(coordinates[1])
          };
        }
      }
      this.zoom = 16;
    },
    drawingMap: function drawingMap() {
      this.shapes = [];
      this.mapMode = 'edit';
      if (!this.editDraw) {
        setTimeout(function () {
          var button = document.getElementsByClassName('editing-map')[0];
          if (button) button.click();
        }, 200);
      }
    },
    deleteDrawing: function deleteDrawing(on) {
      if (on) on.deleteSelection();
      this.shapes = [];
      this.paths = [];
      this.propsEdit = {};
    },
    cancelDrawing: function cancelDrawing(on) {
      if (on) on.deleteSelection();
      this.mapMode = 'ready';
      this.drawingON = false;
      this.shapes = [];
      if (this.editDraw) this.fetchSavedDataURL();
    },
    initDrawing: function initDrawing(on) {
      console.log('Iniciando desenho...');
      this.drawingON = true;
      this.shapes = [];
      this.paths = [];
      on.setDrawingMode('polygon');
    },
    saveDrawing: function () {
      var _saveDrawing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(on) {
        var _this$shapes$, _this$$refs$polygon, path, sizeArea, arrayCoordinates, coordinates, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.setLoading(true);
              this.drawingON = false;
              _context3.p = 1;
              if (!(this.shapes.length > 0 && (_this$shapes$ = this.shapes[0]) !== null && _this$shapes$ !== void 0 && _this$shapes$.overlay)) {
                _context3.n = 2;
                break;
              }
              path = this.shapes[0].overlay.getPath();
              _context3.n = 4;
              break;
            case 2:
              if (!((_this$$refs$polygon = this.$refs.polygon) !== null && _this$$refs$polygon !== void 0 && _this$$refs$polygon.$polygonObject)) {
                _context3.n = 3;
                break;
              }
              path = this.$refs.polygon.$polygonObject.getPath();
              _context3.n = 4;
              break;
            case 3:
              throw new Error('Nenhum desenho ou polígono encontrado para salvar.');
            case 4:
              if (!(!path || typeof path.getArray !== 'function')) {
                _context3.n = 5;
                break;
              }
              throw new Error('Caminho do polígono inválido.');
            case 5:
              sizeArea = window.google.maps.geometry.spherical.computeArea(path);
              if (!(!sizeArea || isNaN(sizeArea))) {
                _context3.n = 6;
                break;
              }
              throw new Error('Erro ao calcular a área do polígono.');
            case 6:
              arrayCoordinates = path.getArray();
              coordinates = arrayCoordinates.map(function (latlng) {
                return {
                  lat: latlng.lat(),
                  lng: latlng.lng()
                };
              });
              this.propsEdit = {
                area: this.formatArea(sizeArea),
                coordinates: coordinates
              };
              this.paths = coordinates;
              if (!(!this.propsEdit.area || !this.propsEdit.coordinates.length)) {
                _context3.n = 7;
                break;
              }
              throw new Error('Dados do desenho incompletos.');
            case 7:
              this.mapMode = 'ready';
              this.showModal = true;
              this.finishDrawingEdit();
              _context3.n = 8;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 100);
              });
            case 8:
              _context3.n = 9;
              return this.printMap();
            case 9:
              this.shapes = []; // Limpa shapes após salvar
              _context3.n = 11;
              break;
            case 10:
              _context3.p = 10;
              _t = _context3.v;
              console.error('Erro ao salvar o desenho:', _t);
              this.$buefy.toast.open({
                duration: 5000,
                message: _t.message || 'Erro ao salvar o desenho no mapa!',
                type: 'is-danger'
              });
            case 11:
              _context3.p = 11;
              this.setLoading(false);
              return _context3.f(11);
            case 12:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 10, 11, 12]]);
      }));
      function saveDrawing(_x) {
        return _saveDrawing.apply(this, arguments);
      }
      return saveDrawing;
    }(),
    finishDrawingEdit: function finishDrawingEdit() {
      this.drawType = '';
      this.propertiesPlot.area = this.propsEdit.area;
      this.propertiesPlot.shape.coordinates = this.propsEdit.coordinates;
      // set coordinates to draw
      this.coordinates = this.propsEdit.coordinates;
      // generate data to open popup
      this.selectedFeatures = [{
        type: 'Feature',
        id: _constants.TYPE_DRAW_MAP,
        geometry: {
          type: 'Polygon',
          coordinates: this.propsEdit.coordinates
        },
        properties: this.propertiesPlot
      }];
      // stop drawing
      this.drawnFeatures = [];

      // generate data to subPlots
      if (!this.editDraw) this.generateSubPlotsDraw();
    },
    handleClickForDelete: function handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject.getPaths().getAt($event.path).removeAt($event.vertex);
      }
    },
    updateEdited: function updateEdited(mvcPath) {
      this.mvcPath = mvcPath;
    },
    printMap: function printMap() {
      var _this = this;
      var options = {
        allowTaint: true,
        useCORS: true,
        logging: true,
        height: window.innerHeight - 220,
        windowHeight: window.innerHeight - 320,
        scale: '1'
      };
      var mapNode = document.querySelector('.vue-map');
      mapNode.setAttribute('style', " left: 0px; top: 10px; transform: none; position: absolute; z-index: 983; width: 100%; height: 500px;");
      (0, _html2canvas.default)(mapNode, options).then(function (canvas) {
        _this.setLoading(false);
        var img = canvas.toDataURL('image/jpeg', 0.7);
        _this.imgArea = img;
        mapNode.removeAttribute('style');
      });
    },
    formatArea: function formatArea(area) {
      return Math.round(area * 100) / 100;
    },
    closeDetail: function closeDetail(id) {
      if (!this.editDraw) this.cancelDrawing();
      this.showModal = false;
    },
    redirect: function redirect(route) {
      this.$router.push({
        path: "/".concat(route)
      });
    },
    updateQtdSuPlot: function updateQtdSuPlot(value) {
      this.subPlotsQtd = Number(value);
      this.generateSubPlotsDraw(value);
    },
    generateSubPlotsDraw: function generateSubPlotsDraw(valueTotal) {
      var total = valueTotal || this.subPlotsQtd;
      var plot = this.propertiesPlot;
      var areSubPlots = plot.area / total;
      this.subPlotsList.code = [];
      this.subPlotsList.area = [];
      for (var index = 0; index < total; index++) {
        this.subPlotsList.code[index] = index + 1;
        this.subPlotsList.area[index] = this.$options.filters.convertAreaNoUnit(areSubPlots);
      }
    },
    editPlotDraw: function () {
      var _editPlotDraw = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var self, center, coordinatesOrigin, coordinatesSet, data, plot;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              self = this;
              center = [self.center.lng, self.center.lat];
              coordinatesOrigin = self.propertiesPlot.shape.coordinates;
              coordinatesSet = [];
              coordinatesOrigin.map(function (i) {
                var item = [i.lng, i.lat];
                coordinatesSet.push(item);
              });
              self.propertiesPlot.shape.coordinates = [coordinatesSet];
              data = {
                id: self.propertiesPlot.id,
                area: self.propertiesPlot.area,
                shape: self.propertiesPlot.shape,
                imageBase64: self.imgArea,
                center: center,
                zoom: self.zoom
              };
              _context4.n = 1;
              return self.updatePlot(data);
            case 1:
              plot = _context4.v;
              if (plot) {
                self.redirect('farm-management/productiveareas/' + plot.id);
              } else self.error = true;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function editPlotDraw() {
        return _editPlotDraw.apply(this, arguments);
      }
      return editPlotDraw;
    }(),
    createNewPlot: function () {
      var _createNewPlot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var self, center, coordinatesOrigin, coordinatesSet, data, plot;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              self = this;
              self.isErrorNickName = false;
              if (self.propertiesPlot.nickName) {
                _context5.n = 1;
                break;
              }
              self.isErrorNickName = true;
              return _context5.a(2);
            case 1:
              if (this.validCalcTotalAreas) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, self.$buefy.toast.open({
                duration: 3000,
                message: "Soma dos subtalh\xF5es maior que a \xE1rea total!",
                type: 'is-danger'
              }));
            case 2:
              center = [self.center.lng, self.center.lat];
              coordinatesOrigin = self.propertiesPlot.shape.coordinates;
              coordinatesSet = [];
              coordinatesOrigin.map(function (i) {
                coordinatesSet.push([i.lng, i.lat]);
              });
              self.propertiesPlot.shape.coordinates = [coordinatesSet];
              data = {
                name: self.propertiesPlot.nickName,
                area: self.propertiesPlot.area,
                shape: self.propertiesPlot.shape,
                imageBase64: self.imgArea,
                center: center,
                zoom: self.zoom
              };
              _context5.n = 3;
              return self.createPlot(data);
            case 3:
              plot = _context5.v;
              if (plot) self.createSubplots(plot);else self.error = true;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function createNewPlot() {
        return _createNewPlot.apply(this, arguments);
      }
      return createNewPlot;
    }(),
    createSubplots: function () {
      var _createSubplots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(plot) {
        var self, subPlots, data, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              self = this;
              subPlots = [];
              self.subPlotsList.code.map(function (item, index) {
                var itemSub = {
                  name: 'Subtalhão',
                  nickname: 'Subtalhão ' + item,
                  area: self.subPlotsList.area[index] / 0.00010000,
                  parentId: plot.id,
                  code: item
                };
                subPlots.push(itemSub);
              });
              data = {
                idPlot: plot.id,
                data: subPlots
              };
              _context6.n = 1;
              return self.createSubPlot(data);
            case 1:
              res = _context6.v;
              if (res) {
                self.redirect('farm-management/productiveareas/' + plot.id);
              } else self.error = true;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function createSubplots(_x2) {
        return _createSubplots.apply(this, arguments);
      }
      return createSubplots;
    }(),
    getAddressDataGeoCode: function getAddressDataGeoCode(e) {
      var value = e.target.value;
      try {
        var lat = Number(value.split(',')[0].trim());
        var lon = Number(value.split(',')[1].trim());
        this.center = [lon, lat];
        this.geolocPosition = [lon, lat];
        this.zoom = 16;
      } catch (error) {
        this.$buefy.toast.open({
          duration: 2000,
          message: "Coordenadas n\xE3o encontradas",
          type: 'is-danger'
        });
      }
    },
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      var lat = Number(addressData.latitude);
      var lon = Number(addressData.longitude);
      this.center = [lon, lat];
      this.geolocPosition = [lon, lat];
      this.zoom = 16;
    }
  })
};